module.exports = __webpack_public_path__ + "img/android-identity.accb0730.png";